module.exports = __webpack_public_path__ + "media/assets/images/blog/network_iot-926c2c2f977fb8577fcdcf42befa22b2.png";